import { createSlice } from '@reduxjs/toolkit';
import { fetchProfileStatus } from '../thunks/fetch-profile-status-thunk';

const initialState = {
    profileStatus: false,
    status: 'idle',
    error: null
};

export const profileStatusSlice = createSlice({
    name: 'profileStatusSlice',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchProfileStatus.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProfileStatus.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.profileStatus = action.payload;
            })
            .addCase(fetchProfileStatus.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    }
});

export const selectProfileStatus = (state) => state.profileStatus.profileStatus;
